import formatNumber from '@/utils/NumberFormatter';
import Validatable from '@/validator/Validatable';

import RevenueSplitItem, { IRevenueSplitItemAPI } from './RevenueSplitItem';

export interface IRevenueSplitCategoryAPI {
  name: string;
  revenue: number;
  revenue_percent: number;
  top_advertisers: IRevenueSplitItemAPI[];
  top_accounts: IRevenueSplitItemAPI[];
  top_buyers: IRevenueSplitItemAPI[];
}

export default class RevenueSplitCategory extends Validatable {
  name: string;
  revenue: number;
  revenuePercent: number;
  topAdvertisers: RevenueSplitItem[];
  topAccounts: RevenueSplitItem[];
  topBuyers: RevenueSplitItem[];

  constructor(name, revenue, revenuePercent, topAdvertisers, topAccounts, topBuyers) {
    super();
    this.name = name;
    this.revenue = revenue;
    this.revenuePercent = revenuePercent;
    this.topAdvertisers = topAdvertisers;
    this.topAccounts = topAccounts;
    this.topBuyers = topBuyers;
  }

  get tops() {
    return [
      { id: 'ADVERTISERS', children: this.topAdvertisers },
      { id: 'ACCOUNTS', children: this.topAccounts },
      { id: 'BUYERS', children: this.topBuyers },
    ];
  }

  get revenueFormatted() {
    return `${Math.round(this.revenue)}`.length % 3 === 0
      ? formatNumber(this.revenue, '$0a')
      : formatNumber(this.revenue, '$0.0a');
  }

  static fromApi(apiObject: IRevenueSplitCategoryAPI) {
    return new RevenueSplitCategory(
      apiObject.name,
      apiObject.revenue,
      apiObject.revenue_percent / 100,
      apiObject.top_advertisers?.map((x) => RevenueSplitItem.fromApi(x)),
      apiObject.top_accounts?.map((x) => RevenueSplitItem.fromApi(x)),
      apiObject.top_buyers?.map((x) => RevenueSplitItem.fromApi(x)),
    );
  }
}
